import client from './client';

// "My notifications" feed — newest first. Used by the notification
// preferences page to show recent send history; the future in-app
// bell will reuse this.
export const listMyNotifications = (params) =>
  client.get('/me/notifications', { params }).then((r) => r.data);

// Per-user notification toggles. Defaults are applied server-side
// when no row exists for the user, so the response is always
// populated.
export const getMyPreferences = () =>
  client.get('/me/preferences').then((r) => r.data);

// Partial update — send only the fields you want to change.
export const updateMyPreferences = (patch) =>
  client.put('/me/preferences', patch).then((r) => r.data);
